import { IonButton, RouterDirection } from "@ionic/react";
import { useTheme } from "react-jss";
import "./button.css";
import { ButtonStyle } from "./buttonStyle.jss";

interface IButtonProps {
    onClick?: (ev?: any) => any;
    title: string;
    color?: string;
    className?: string;
    slot?: string;
    disabled?: boolean;
    link?: string;
    direction?: RouterDirection;
}

export const Button: React.FC<IButtonProps> = ({ onClick, title, color, className, slot, disabled, link, direction }) => {
    const theme = useTheme();
    const style = ButtonStyle({ theme });

    return (
        <div className={style.container}>
            <IonButton
                className={`${className}`}
                routerLink={link}
                routerDirection={direction}
                expand="full"
                onClick={onClick}
                color={color}
                slot={slot}
                disabled={disabled}
            >
                {title}
            </IonButton>
        </div>
    );
};
export const ButtonWithInverse: React.FC<IButtonProps> = ({ onClick, title, disabled }) => {
    const theme = useTheme();
    const style = ButtonStyle({ theme });

    return (
        <div className={style.container}>
            <IonButton
                className={"withInverse"}
                expand="full"
                onClick={onClick}
                disabled={disabled}
            >
                {title}
            </IonButton>
        </div>
    );
};
